import { Injectable } from '@angular/core';

import { FinanciacionPropiaService } from '../../../../modules/finanzas/financiacion-propia/financiacion-propia.service';
import { FinanciacionPropiaModel } from '../../../../modules/finanzas/financiacion-propia/financiacion-propia.model';
import { ensureOk } from '../../entity-form/entity-form.utils';

@Injectable({ providedIn: 'root' })
export class OwnFinancingEntityService {

  constructor(private financiacionPropiaService: FinanciacionPropiaService) { }

  get(uid: string): Promise<FinanciacionPropiaModel> {
    return this.financiacionPropiaService.get(uid).then(financing => {
      if (!financing) throw new Error();
      return financing;
    });
  }

  create(payload: FinanciacionPropiaModel): Promise<void> {
    return this.financiacionPropiaService.add(payload).then(() => undefined);
  }

  update(uid: string, payload: FinanciacionPropiaModel): Promise<void> {
    return this.financiacionPropiaService.edit({ ...payload, uid }).then(ensureOk);
  }
}
